import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { MockApiInterceptor } from './interceptors/mock-api.interceptor';

// Services
import { AdminService } from './services/admin.service';
import { AuthenticationService } from './services/authentication.service';
import { BetsService } from './services/bets.service';
import { EventsService } from './services/events.service';
import { DataExchangeService } from './services/data-exchange.service';
import { Routes, RouterModule } from '@angular/router';
// Guards
import { AdminAuthGuardService } from './auth/admin.auth.guard';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';


@NgModule({
  declarations: [
    AppComponent

  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    MatSnackBarModule,
    BrowserAnimationsModule,
    RouterModule.forRoot([]),
    HttpClientModule,
    HammerModule,
    DragDropModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MockApiInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    AdminService,
    AuthenticationService,
    BetsService,
    DataExchangeService,
    EventsService,
    AdminAuthGuardService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
